import TwinEqualCTA from '@global/Blocks/TwinEqualCTA'

const NearbySuburbs = ({ title, nearbySuburbs, viewMoreLink }) => {
  return (
    <TwinEqualCTA
      bgColor='white'
      title={title}
      titleStyle='flex'
      items={nearbySuburbs}
      roundedItem
      viewMoreLink={viewMoreLink}
      size='sm'
      numberOfItems={3}
    />
  )
}

export default NearbySuburbs
